module.exports = __webpack_public_path__ + "static/img/image.9e75e2fe.jpeg";